export default [
  {
    path: '/active-z-character/index',
    name: 'index',
    component: () => import('@/views/active-z-character'),
    meta: {
      title: '解锁Z时代天赋-高考直通车'
    }
  },
  
]
